export const RootId = 'D84927C4-E682-EA11-80CF-97CC0449692F';

export const APPLICATION = {
  ThongTinQuyHoach: '3F065E10-F481-EA11-8426-000C2903F0F6',
  QuanLyThongTinQuyHoach: 'E849D7A9-F573-EA11-80CF-97CC0449692F',
  QuanLyHaTangKyThuatGIS: '1406C8B0-F573-EA11-80CF-97CC0449692F',
  QuanLyCongTrinhCaoTang: 'A76AE350-1783-EA11-80CF-97CC0449692F',
  QuanLySuCo: 'DEEB3B8F-3984-EA11-80B8-000C2985A49C',
  QuanLySuCoDonVi: '19A5F7F2-4684-EA11-80B8-000C2985A49C',
  TiepNhanSuCo: 'C3F25AB0-3984-EA11-80B8-000C2985A49C',
  XemDuLieu: '5C16CB3D-7B83-EA11-80B8-000C2985A49C',
  ThongTinVatLieuXayDung: '7EB233B7-F573-EA11-80CF-97CC0449692F',
  QuanLyhHaTangThuongMai: '4530A19A-64F3-EB11-80CB-000C2906E5A6',
  LuuTruQuyHoach: '15ACC4F4-1984-EA11-80B8-000C2985A49C',
  TongQuanChuyenDeGIS: 'A8695595-E082-EA11-80CF-97CC0449692F'
};
